module.exports = __webpack_public_path__ + "static/media/service-ac-citra-raya-6.ad9f2cf.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/service-ac-citra-raya-6.mp4
// module id = k4Pd
// module chunks = 0